import React, { useRef, useState } from 'react';
import './schedule.css';
import Layout from '../components/layout';
import { useGsapAnimations } from '../hooks/useGsapAnimations';

const days = ['Today', 'Tomorrow', 'Day 3'];

const sessions = [
  {
    day: 'Today',
    time: '10:00',
    title: 'Opening Keynote',
    location: 'Main Stage',
    type: 'Keynote',
    status: 'Live',
  },
  {
    day: 'Today',
    time: '11:30',
    title: 'AI Motion Lab',
    location: 'Immersive Hall',
    type: 'Experience',
    status: 'Next',
  },
  {
    day: 'Today',
    time: '13:00',
    title: 'Startup Arena',
    location: 'Pitch Zone',
    type: 'Startup',
    status: 'Open',
  },
  {
    day: 'Today',
    time: '15:30',
    title: 'XR Space',
    location: 'Future Lab',
    type: 'Workshop',
    status: 'Open',
  },
  {
    day: 'Tomorrow',
    time: '10:30',
    title: 'Future Mobility',
    location: 'Main Stage',
    type: 'Panel',
    status: 'Open',
  },
  {
    day: 'Tomorrow',
    time: '12:00',
    title: 'Creative Coding Lab',
    location: 'Studio B',
    type: 'Workshop',
    status: 'Open',
  },
  {
    day: 'Tomorrow',
    time: '14:30',
    title: 'FinTech Founders',
    location: 'Pitch Zone',
    type: 'Startup',
    status: 'Open',
  },
  {
    day: 'Day 3',
    time: '11:00',
    title: 'Climate Tech Forum',
    location: 'Forum Room',
    type: 'Panel',
    status: 'Open',
  },
  {
    day: 'Day 3',
    time: '16:00',
    title: 'Closing Showcase',
    location: 'Main Stage',
    type: 'Showcase',
    status: 'Open',
  },
];

const Schedule = () => {
  const [selectedDay, setSelectedDay] = useState(days[0]);
  const pageRef = useRef(null);
  const filteredSessions = sessions.filter((session) => session.day === selectedDay);

  useGsapAnimations(pageRef, selectedDay);

  return (
    <Layout>
      <div className="schedule_page" ref={pageRef}>
        <section className="schedule_header" data-gsap-intro>
          <p>EVENT SCHEDULE</p>
          <h1>Plan your day</h1>
        </section>

        <section className="schedule_day_tabs" aria-label="Schedule days" role="tablist" data-gsap-stagger="children" data-gsap-start="top 96%">
          {days.map((day) => (
            <button
              className={`schedule_day_tab ${selectedDay === day ? 'active_day_tab' : ''}`}
              key={day}
              type="button"
              onClick={() => setSelectedDay(day)}
              role="tab"
              aria-selected={selectedDay === day}
            >
              {day}
            </button>
          ))}
        </section>

        <section className="schedule_now" data-gsap-reveal data-gsap-scale="0.94">
          <div>
            <span className="schedule_live_dot" data-gsap-pulse />
            <p>Happening now</p>
          </div>
          <h2>{filteredSessions[0]?.title}</h2>
          <span>{filteredSessions[0]?.location}</span>
        </section>

        <div className="section_label schedule_label" data-gsap-reveal data-gsap-direction="left">
          <span className="label_line" />
          <p>{selectedDay.toUpperCase()}</p>
        </div>

        <section className="schedule_list" data-gsap-stagger=".schedule_card" data-gsap-start="top 90%">
          {filteredSessions.map((session) => (
            <article className="schedule_card" key={`${session.day}-${session.time}-${session.title}`}>
              <div className="schedule_time">
                <strong>{session.time}</strong>
                <span>{session.status}</span>
              </div>

              <div className="schedule_details">
                <div className="schedule_card_header">
                  <span>{session.type}</span>
                  <p>{session.location}</p>
                </div>
                <h2>{session.title}</h2>
              </div>
            </article>
          ))}
        </section>
      </div>
    </Layout>
  );
};

export default Schedule;
